import { isAxiosError } from 'axios';
import { z } from 'zod';
import { $RegistrationErrorData } from './types';

const responseSchema = z.object({ data: $RegistrationErrorData });

export const getRegistrationError = (error: unknown) => {
  if (!isAxiosError<unknown>(error)) {
    return undefined;
  }
  const parsed = responseSchema.safeParse(error.response?.data);
  return parsed.success ? parsed.data.data : undefined;
};
